/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
/* eslint-disable import/no-unresolved, import/default */

import entityTableTemplate from '../table/entity-table.tpl.html';
import dashboardTemplate from './dashboard/dashboard.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
export default function GatewayRoutes($stateProvider, $injector) {

    var types = $injector.get('types');

    $stateProvider
        .state('home.gatewayGroups.gateways', {
            url: '/:gatewayGroupId/gateways',
            module: 'private',
            auth: [types.authority.PROVIDER_ADMIN.value, types.authority.PROVIDER_USER.value,
                   types.authority.CUSTOMER_ADMIN.value, types.authority.CUSTOMER_USER.value],
            views: {
                "content@home": {
                    templateUrl: entityTableTemplate,
                    controllerAs: 'vm',
                    controller: 'EntityTableController'
                }
            },
            data: {
                searchEnabled: false,
                pageTitle: 'gateway.gateways'
            },
            ncyBreadcrumb: {
                label: '{"icon": "router", "label": "gateway.gateways"}'
            },
            params: {
                entityId: null,
            },
            resolve: {
                entityTableConfiguration:
                /*@ngInject*/
                    function($stateParams, gatewayTableConfig) {
                        return gatewayTableConfig.getConfig($stateParams);
                    }
            }
        })
        .state('home.customers.gatewayGroups.gateways', {
            url: '/:gatewayGroupId/gateways',
            module: 'private',
            auth: [types.authority.PROVIDER_ADMIN.value, types.authority.PROVIDER_USER.value],
            views: {
                "content@home": {
                    templateUrl: entityTableTemplate,
                    controllerAs: 'vm',
                    controller: 'EntityTableController'
                }
            },
            data: {
                searchEnabled: false,
                pageTitle: 'gateway.gateways'
            },
            ncyBreadcrumb: {
                label: '{"icon": "router", "label": "gateway.gateways"}'
            },
            resolve: {
                entityTableConfiguration:
                /*@ngInject*/
                    function($stateParams, gatewayTableConfig) {
                        return gatewayTableConfig.getConfig($stateParams);
                    }
            }
        })
        .state('home.gateways', {
            url: '/gateways',
            module: 'private',
            auth: [types.authority.PROVIDER_ADMIN.value, types.authority.PROVIDER_USER.value,
                   types.authority.CUSTOMER_ADMIN.value, types.authority.CUSTOMER_USER.value],
            views: {
                "content@home": {
                    templateUrl: entityTableTemplate,
                    controllerAs: 'vm',
                    controller: 'EntityTableController'
                }
            },
            data: {
                searchEnabled: false,
                pageTitle: 'gateway.gateways'
            },
            ncyBreadcrumb: {
                label: '{"icon": "router", "label": "gateway.gateways"}'
            },
            params: {
                entityId: null,
            },
            resolve: {
                entityTableConfiguration:
                /*@ngInject*/
                    function($stateParams, gatewayTableConfig) {
                        return gatewayTableConfig.getConfig($stateParams);
                    }
            }
        })

    // eslint-disable-next-line
    if (window.DynamicConfigs.grafanaEnabled === "true") {
        $stateProvider
            .state('home.gateways.dashboard', {
                url: '/dashboard',
                module: 'private',
                auth: [types.authority.PROVIDER_ADMIN.value, types.authority.PROVIDER_USER.value,
                types.authority.CUSTOMER_ADMIN.value, types.authority.CUSTOMER_USER.value],
                views: {
                    "content@home": {
                        templateUrl: dashboardTemplate,
                        controllerAs: 'vm',
                        controller: 'GatewayDashboardController'
                    }
                },
                data: {
                    searchEnabled: false,
                    pageTitle: 'gateway.dashboard'
                },
                ncyBreadcrumb: {
                    label: '{"icon": "dashboard", "label": "gateway.dashboard"}'
                }
            })
            .state('home.gatewayGroups.gateways.dashboard', {
                url: '/dashboard',
                module: 'private',
                auth: [types.authority.PROVIDER_ADMIN.value, types.authority.PROVIDER_USER.value,
                types.authority.CUSTOMER_ADMIN.value, types.authority.CUSTOMER_USER.value],
                views: {
                    "content@home": {
                        templateUrl: dashboardTemplate,
                        controllerAs: 'vm',
                        controller: 'GatewayDashboardController'
                    }
                },
                data: {
                    searchEnabled: false,
                    pageTitle: 'gateway.dashboard'
                },
                ncyBreadcrumb: {
                    label: '{"icon": "dashboard", "label": "gateway.dashboard"}'
                },
                resolve: {
                    entityTableConfiguration:
                        /*@ngInject*/
                        function ($stateParams, gatewayTableConfig) {
                            return gatewayTableConfig.getConfig($stateParams);
                        }
                }
            })
    }
}



// WEBPACK FOOTER //
// ./src/app/gateway/gateway.routes.js